import React, { useLayoutEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { DropdownItem, DropdownMenu, Icon, TooltipType, TsrSvgIcon, TsrTooltip } from 'tacho-ui';
import style from './style.module.scss';

interface LoginStatusProps {
    firstname: string;
    lastname: string;
    onLogout: () => void;
}

const MAX_USER_INFO_WIDTH = 200;

export function LoginStatusComponent(props: React.PropsWithChildren<LoginStatusProps>): JSX.Element {
    const [showDetails, setShowDetails] = useState(false);
    const [userInfoWidth, setUserInfoWidth] = useState(0);
    const userInfoRef = useRef<HTMLSpanElement>(null);
    const toggleDetails = () => setShowDetails(!showDetails);

    const { formatMessage } = useIntl();

    const options = [
        {
            label: formatMessage({ id: 'loggedUserAccountSettings' }),
            onItemClick: () => toggleDetails(),
            iconName: Icon.Settings,
        },
        {
            label: formatMessage({ id: 'loginStatusLogout' }),
            onItemClick: () => props.onLogout(),
            iconName: Icon.Logout,
        },
    ] as Array<DropdownItem>;

    useLayoutEffect(() => {
        setUserInfoWidth(userInfoRef.current?.offsetWidth as number);
    });

    const username = `${props.firstname} ${props.lastname}`;

    return (
        <>
            {props.firstname && props.lastname && (
                <DropdownMenu items={options}>
                    <div className={style.loginStatusWrapper}>
                        <TsrSvgIcon icon={Icon.User} titleIcon cursor="pointer" />
                        <span ref={userInfoRef} className={style.loginUserInfo}>
                            {userInfoWidth === MAX_USER_INFO_WIDTH ? (
                                <TsrTooltip type={TooltipType.Info} icon={false} content={username}>
                                    <span className={style.username}>{username}</span>
                                </TsrTooltip>
                            ) : (
                                <span className={style.username}>{username}</span>
                            )}
                        </span>
                    </div>
                </DropdownMenu>
            )}
        </>
    );
}
